import { c as _c } from "react/compiler-runtime";
import { IdDocImageTypes } from '@onefootprint/types';
import { Button } from '@onefootprint/ui';
import upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';
import { NavigationHeader } from '@/idv/components';
import DesktopHeader from '../../../components/desktop-header';
import ErrorComponent from '../../../components/error';
import useDocName from '../../hooks/use-doc-name';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
const DesktopSelfieRetry = () => {
  const $ = _c(34);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.id-doc.pages.desktop-selfie-retry"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  const [state, send] = useIdDocMachine();
  const {
    errors
  } = state.context;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      imageType: IdDocImageTypes.selfie
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    getSideName
  } = useDocName(t1);
  let T0;
  let handleSelfieRetake;
  let sideName;
  let t2;
  let t3;
  let t4;
  if ($[2] !== getSideName || $[3] !== send) {
    sideName = getSideName();
    let t5;
    if ($[10] !== send) {
      t5 = () => {
        send({
          type: "startImageCapture"
        });
      };
      $[10] = send;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    handleSelfieRetake = t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <NavigationHeader leftButton={{
        variant: "close",
        confirmClose: true
      }} />;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t3 = "flex flex-col gap-6 pb-4";
    T0 = DesktopHeader;
    t2 = upperFirst(sideName);
    $[2] = getSideName;
    $[3] = send;
    $[4] = T0;
    $[5] = handleSelfieRetake;
    $[6] = sideName;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    T0 = $[4];
    handleSelfieRetake = $[5];
    sideName = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[13] !== T0 || $[14] !== t2) {
    t5 = <T0 sideName={t2} isSelfie={true} />;
    $[13] = T0;
    $[14] = t2;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== errors) {
    t6 = errors ?? [{
      errorType: "unknown_error"
    }];
    $[16] = errors;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== sideName || $[19] !== t6) {
    t7 = <div className="flex flex-col justify-center items-center bg-secondary border border-dashed border-primary rounded px-5 min-h-[280px]"><ErrorComponent errors={t6} sideName={sideName} /></div>;
    $[18] = sideName;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t) {
    t8 = t(_temp);
    $[21] = t;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== handleSelfieRetake || $[24] !== t8) {
    t9 = <Button fullWidth={true} onClick={handleSelfieRetake} size="large" data-dd-action-name="selfie:retry">{t8}</Button>;
    $[23] = handleSelfieRetake;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t3 || $[27] !== t5 || $[28] !== t7 || $[29] !== t9) {
    t10 = <div className={t3}>{t5}{t7}{t9}</div>;
    $[26] = t3;
    $[27] = t5;
    $[28] = t7;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t4) {
    t11 = <>{t4}{t10}</>;
    $[31] = t10;
    $[32] = t4;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};
export default DesktopSelfieRetry;
function _temp($) {
  return $["take-selfie-again"];
}